module.exports = __webpack_public_path__ + "static/media/loginpage.fb4fb104.png";